export class InvestgationReqMode{
patientcode = '' ;
invdate = '2024-01-01' ;
invdescription = '' ;
invnotes = '' ;
compcode = '' ;
userid = '' ;
modeficationdate = '2024-01-01' ;

}
export class ScanReqModel{
  patientcode = '' ;
  scandate = '2024-01-01' ;
  scandescription = '' ;
  scannotes = '' ;
  compcode = '' ;
  userid = '' ;
  modeficationdate = '2024-01-01' ;

  }
